(function () {
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function initAnnouncement(section) {
    const slides = Array.from(section.querySelectorAll('.nuby-announcement__slide'));
    const prev = section.querySelector('[data-announcement-prev]');
    const next = section.querySelector('[data-announcement-next]');
    if (slides.length <= 1) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    let index = 0;
    let timer = null;
    const seconds = Number(section.dataset.autoplay || 5);

    function render() {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      timer = window.setInterval(() => {
        index = (index + 1) % slides.length;
        render();
      }, seconds * 1000);
    }

    if (prev) {
      prev.addEventListener('click', () => {
        index = (index - 1 + slides.length) % slides.length;
        render();
        start();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        index = (index + 1) % slides.length;
        render();
        start();
      });
    }

    render();
    start();
  }

  function initDrawer(root) {
    const drawer = root.querySelector('[data-nuby-drawer]');
    const backdrop = root.querySelector('[data-nuby-drawer-backdrop]');
    const openers = root.querySelectorAll('[data-nuby-open-drawer]');
    const closers = root.querySelectorAll('[data-nuby-close-drawer]');
    if (!drawer || !backdrop || !openers.length) {
      return;
    }

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      backdrop.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    openers.forEach((button) => {
      button.addEventListener('click', () => setOpen(true));
    });

    closers.forEach((button) => {
      button.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    });
  }

  function initCarousel(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const items = Array.from(section.querySelectorAll('.nuby-carousel__item'));
    if (!viewport || !items.length) {
      return;
    }

    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    const counter = section.querySelector('[data-carousel-counter]');
    const dotsRoot = section.querySelector('[data-carousel-dots]');

    function getPositions() {
      return items.map((item) => Math.max(0, Math.round(item.offsetLeft)));
    }

    function getCurrentIndex() {
      const positions = getPositions();
      const currentLeft = Math.round(viewport.scrollLeft);
      let bestIndex = 0;
      let bestDistance = Number.POSITIVE_INFINITY;

      positions.forEach((position, index) => {
        const distance = Math.abs(position - currentLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    function scrollToIndex(targetIndex) {
      const positions = getPositions();
      const index = clamp(targetIndex, 0, positions.length - 1);
      viewport.scrollTo({
        left: positions[index] || 0,
        behavior: 'smooth'
      });
    }

    function renderDots(total, current) {
      if (!dotsRoot) {
        return;
      }

      const existing = Array.from(dotsRoot.querySelectorAll('[data-carousel-dot]'));
      if (existing.length !== total) {
        dotsRoot.innerHTML = '';
        for (let index = 0; index < total; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'nuby-carousel__dot';
          dot.dataset.carouselDot = '';
          dot.addEventListener('click', () => scrollToIndex(index));
          dotsRoot.appendChild(dot);
        }
      }

      Array.from(dotsRoot.querySelectorAll('[data-carousel-dot]')).forEach((dot, index) => {
        dot.classList.toggle('is-active', index === current);
      });
    }

    function update() {
      const current = getCurrentIndex();
      const total = items.length;
      if (counter) {
        counter.textContent = current + 1 + ' / ' + total;
      }
      if (prev) {
        prev.disabled = current <= 0;
      }
      if (next) {
        next.disabled = current >= total - 1;
      }
      renderDots(total, current);
    }

    if (prev) {
      prev.addEventListener('click', () => scrollToIndex(getCurrentIndex() - 1));
    }

    if (next) {
      next.addEventListener('click', () => scrollToIndex(getCurrentIndex() + 1));
    }

    let ticking = false;
    viewport.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    });

    window.addEventListener('resize', update);
    update();
  }

  async function hydrateProductCarousels() {
    const wrappers = Array.from(document.querySelectorAll('.shopify-section')).filter((section) => {
      return section.id && section.querySelector('[data-nuby-carousel]');
    });

    for (const wrapper of wrappers) {
      const sectionId = wrapper.id.replace(/^shopify-section-/, '');
      if (!sectionId) {
        continue;
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('carousel_refresh', String(Date.now()));

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: {
            'Cache-Control': 'no-cache'
          }
        });

        if (!response.ok) {
          continue;
        }

        const html = await response.text();
        if (!html) {
          continue;
        }

        const next = document.createElement('div');
        next.innerHTML = html;
        const freshWrapper = next.querySelector('.shopify-section');
        if (!freshWrapper || !freshWrapper.querySelector('[data-nuby-carousel]')) {
          continue;
        }

        wrapper.replaceWith(freshWrapper);
      } catch (error) {
        console.warn('Carousel hydration failed.', error);
      }
    }
  }

  function initSocial(section) {
    const track = section.querySelector('[data-social-track]');
    const pagination = section.querySelector('[data-social-pagination]');
    if (!track || !pagination) {
      return;
    }

    function getPageCount() {
      if (window.innerWidth > 749) {
        return 0;
      }
      return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
    }

    function updateDots() {
      const dots = Array.from(pagination.querySelectorAll('button'));
      if (!dots.length) {
        return;
      }

      const maxPage = getPageCount() - 1;
      const current = clamp(Math.round(track.scrollLeft / track.clientWidth), 0, Math.max(0, maxPage));
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === current);
      });
    }

    function renderDots() {
      const total = getPageCount();
      pagination.innerHTML = '';
      if (total <= 1) {
        return;
      }

      for (let index = 0; index < total; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.addEventListener('click', () => {
          track.scrollTo({
            left: index * track.clientWidth,
            behavior: 'smooth'
          });
        });
        pagination.appendChild(dot);
      }

      updateDots();
    }

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateDots();
        ticking = false;
      });
    });

    window.addEventListener('resize', renderDots);
    renderDots();
  }

  function initRichText(section) {
    const toggle = section.querySelector('[data-richtext-toggle]');
    const content = section.querySelector('[data-richtext-content]');
    if (!toggle || !content) {
      return;
    }

    const moreLabel = toggle.dataset.more || 'Read more';
    const lessLabel = toggle.dataset.less || 'Read less';

    toggle.addEventListener('click', () => {
      const expanded = content.classList.toggle('is-expanded');
      toggle.textContent = expanded ? lessLabel : moreLabel;
    });
  }

  function initFooterAccordion(root) {
    const toggles = Array.from(root.querySelectorAll('[data-footer-toggle]'));
    toggles.forEach((toggle) => {
      const panel = toggle.parentElement.querySelector('[data-footer-panel]');
      if (!panel) {
        return;
      }

      toggle.addEventListener('click', () => {
        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

        toggles.forEach((otherToggle) => {
          const otherPanel = otherToggle.parentElement.querySelector('[data-footer-panel]');
          if (!otherPanel) {
            return;
          }

          const isCurrent = otherToggle === toggle;
          otherToggle.setAttribute('aria-expanded', isCurrent && willOpen ? 'true' : 'false');
          otherPanel.hidden = !(isCurrent && willOpen);

          const plus = otherToggle.querySelector('.nuby-footer__accordion-plus');
          if (plus) {
            plus.textContent = isCurrent && willOpen ? '-' : '+';
          }
        });
      });
    });
  }

  function initPreviewForms(root) {
    root.querySelectorAll('[data-nuby-preview-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
      });
    });
  }

  async function boot() {
    document.querySelectorAll('[data-nuby-announcement]').forEach(initAnnouncement);
    document.querySelectorAll('[data-nuby-social]').forEach(initSocial);
    document.querySelectorAll('[data-nuby-richtext]').forEach(initRichText);
    document.querySelectorAll('[data-nuby-shell]').forEach(initDrawer);
    initPreviewForms(document);
    await hydrateProductCarousels();
    document.querySelectorAll('[data-nuby-carousel]').forEach(initCarousel);
    document.querySelectorAll('.nuby-footer').forEach(initFooterAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      void boot();
    });
  } else {
    void boot();
  }
})();
